import { Badge } from './badge'

interface StatusBadgeProps {
  readonly active: boolean
  readonly activeLabel?: string
  readonly inactiveLabel?: string
  readonly className?: string
}

export function StatusBadge({
  active,
  activeLabel = 'Ativa',
  inactiveLabel = 'Inativa',
  className,
}: StatusBadgeProps) {
  return (
    <Badge tone={active ? 'success' : 'neutral'} className={className}>
      {active ? activeLabel : inactiveLabel}
    </Badge>
  )
}
